module.exports = __webpack_public_path__ + "static/media/xrayshoulder.7dbec674.png";